import { DependencyContainer } from 'tsyringe'
import { AuthDataMapper } from '@/data/persistences/mappers/AuthDataMapper'
import { AuthApiRepository } from '@/app/repositories/api/AuthApiRepository'
import ApiService from '../services/ApiServices'
import { UserApiRepository } from '@/app/repositories/api/UserApiRepository'
import { UserDataMapper } from '@/data/persistences/mappers/UserDataMapper'
import { RoleApiRepository } from '@/app/repositories/api/RoleApiRepository'
import { RoleDataMapper } from '@/data/persistences/mappers/RoleDataMapper'
import { DashboardApiRepository } from '@/app/repositories/api/DashboardApiRepository'
import { DashboardDataMapper } from '@/data/persistences/mappers/DashboardDataMapper'
import { NotificationApiRepository } from '@/app/repositories/api/NotificationApiRepository'
import { NotificationDataMapper } from '@/data/persistences/mappers/NotificationDataMapper'
import { HomebannerApiRepository } from '@/app/repositories/api/HomebannerApiRepository'
import { HomebannerDataMapper } from '@/data/persistences/mappers/HomebannerDataMapper'
import { AdditionalInfoApiRepository } from '@/app/repositories/api/AdditionalInfoApiRepository'
import { AdditionalInfoDataMapper } from '@/data/persistences/mappers/AdditionalInfoDataMapper'
import { BulletinApiRepository } from '@/app/repositories/api/BulletinApiRepository'
import { BulletinDataMapper } from '@/data/persistences/mappers/BulletinDataMapper'
import { FAQApiRepository } from '@/app/repositories/api/FAQApiRepository'
import { FAQDataMapper } from '@/data/persistences/mappers/FAQDataMapper'
import { TrainingCategoryApiRepository } from '@/app/repositories/api/TrainingCategoryRepository'
import { TrainingCategoryDataMapper } from '@/data/persistences/mappers/TrainingCategoryDataMapper'
import { GuideCategoryApiRepository } from '@/app/repositories/api/GuideCategoryRepository'
import { GuideCategoryDataMapper } from '@/data/persistences/mappers/GuideCategoryDataMapper'
import { RecomendationApiRepository } from '@/app/repositories/api/RecomendationApiRepository'
import { RecomendationDataMapper } from '@/data/persistences/mappers/RecomendationDataMapper'
import { TrainingMaterialApiRepository } from '@/app/repositories/api/TrainingMaterialRepository'
import { TrainingMaterialDataMapper } from '@/data/persistences/mappers/TrainingMaterialDataMapper'
import { GuideMaterialApiRepository } from '@/app/repositories/api/GuideMaterialRepository'
import { GuideMaterialDataMapper } from '@/data/persistences/mappers/GuideMaterialDataMapper'
import { GalleryImageApiRepository } from '@/app/repositories/api/GalleryImageRepository'
import { GalleryImageDataMapper } from '@/data/persistences/mappers/GalleryImageDataMapper'
import { OtherContentApiRepository } from '@/app/repositories/api/OtherContentApiRepository'
import { OtherContentDataMapper } from '@/data/persistences/mappers/OtherContentDataMapper'
import { PositionApiRepository } from '@/app/repositories/api/PositionApiRepository'
import { PositionDataMapper } from '@/data/persistences/mappers/PositionDataMapper'
import { MasterCarApiRepository } from '@/app/repositories/api/MasterCarApiRepository'
import { MasterCarDataMapper } from '@/data/persistences/mappers/MasterCarDataMapper'
import { MasterApiRepository } from '@/app/repositories/api/MasterApiRepository'
import { MasterDataMapper } from '@/data/persistences/mappers/MasterDataMapper'
import { UserReportApiRepository } from '@/app/repositories/api/UserReportApiRepository'
import { UserReportDataMapper } from '@/data/persistences/mappers/UserReportDataMapper'
import { AdminCMSApiRepository } from '@/app/repositories/api/AdminCMSApiRepository'
import { AdminCMSMapper } from '@/data/persistences/mappers/AdminCMSMapper'
import { AdminCMSRoleApiRepository } from '@/app/repositories/api/AdminCMSRoleApiRepository'
import { AdminCMSRoleDataMapper } from '@/data/persistences/mappers/AdminCMSRoleDataMapper'
import { BulletinReportApiRepository } from '@/app/repositories/api/BulletinReportApiRepository'
import { BulletinReportDataMapper } from '@/data/persistences/mappers/BulletinReportDataMapper'
import { AdditionalInfoReportApiRepository } from '@/app/repositories/api/AdditionalInfoReportApiRepository'
import { AdditionalInfoReportDataMapper } from '@/data/persistences/mappers/AdditionalInfoReportDataMapper'
import { TrainingMaterialReportApiRepository } from '@/app/repositories/api/TrainingMaterialReportApiRepository'
import { TrainingMaterialReportDataMapper } from '@/data/persistences/mappers/TrainingMaterialReportDataMapper'
import { QuickGuideReportApiRepository } from '@/app/repositories/api/QuickGuideReportApiRepository'
import { QuickGuideReportDataMapper } from '@/data/persistences/mappers/QuickGuideReportDataMappers'
import { NotificationReportApiRepository } from '@/app/repositories/api/NotificationReportApiRepository'
import { NotificationReportDataMapper } from '@/data/persistences/mappers/NotificationReportDataMapper'

export class RepositoryModule {
  public static init(container: DependencyContainer) {
    container.register<AuthApiRepository>(AuthApiRepository, {
      useFactory: (d) => {
        return new AuthApiRepository(
          d.resolve(ApiService),
          d.resolve(AuthDataMapper)
        )
      },
    })
    container.register<UserApiRepository>(UserApiRepository, {
      useFactory: (d) => {
        return new UserApiRepository(
          d.resolve(ApiService),
          d.resolve(UserDataMapper)
        )
      },
    })
    container.register<RoleApiRepository>(RoleApiRepository, {
      useFactory: (d) => {
        return new RoleApiRepository(
          d.resolve(ApiService),
          d.resolve(RoleDataMapper)
        )
      },
    })
    container.register<DashboardApiRepository>(DashboardApiRepository, {
      useFactory: (d) => {
        return new DashboardApiRepository(
          d.resolve(ApiService),
          d.resolve(DashboardDataMapper)
        )
      },
    })
    container.register<NotificationApiRepository>(NotificationApiRepository, {
      useFactory: (d) => {
        return new NotificationApiRepository(
          d.resolve(ApiService),
          d.resolve(NotificationDataMapper)
        )
      },
    })
    container.register<HomebannerApiRepository>(HomebannerApiRepository, {
      useFactory: (d) => {
        return new HomebannerApiRepository(
          d.resolve(ApiService),
          d.resolve(HomebannerDataMapper)
        )
      },
    })
    container.register<AdditionalInfoApiRepository>(
      AdditionalInfoApiRepository,
      {
        useFactory: (d) => {
          return new AdditionalInfoApiRepository(
            d.resolve(ApiService),
            d.resolve(AdditionalInfoDataMapper)
          )
        },
      }
    )
    container.register<BulletinApiRepository>(BulletinApiRepository, {
      useFactory: (d) => {
        return new BulletinApiRepository(
          d.resolve(ApiService),
          d.resolve(BulletinDataMapper)
        )
      },
    })
    container.register<FAQApiRepository>(FAQApiRepository, {
      useFactory: (d) => {
        return new FAQApiRepository(
          d.resolve(ApiService),
          d.resolve(FAQDataMapper)
        )
      },
    })
    container.register<TrainingCategoryApiRepository>(
      TrainingCategoryApiRepository,
      {
        useFactory: (d) => {
          return new TrainingCategoryApiRepository(
            d.resolve(ApiService),
            d.resolve(TrainingCategoryDataMapper)
          )
        },
      }
    )
    container.register<GuideCategoryApiRepository>(GuideCategoryApiRepository, {
      useFactory: (d) => {
        return new GuideCategoryApiRepository(
          d.resolve(ApiService),
          d.resolve(GuideCategoryDataMapper)
        )
      },
    })
    container.register<RecomendationApiRepository>(RecomendationApiRepository, {
      useFactory: (d) => {
        return new RecomendationApiRepository(
          d.resolve(ApiService),
          d.resolve(RecomendationDataMapper)
        )
      },
    })
    container.register<TrainingMaterialApiRepository>(
      TrainingMaterialApiRepository,
      {
        useFactory: (d) => {
          return new TrainingMaterialApiRepository(
            d.resolve(ApiService),
            d.resolve(TrainingMaterialDataMapper)
          )
        },
      }
    )
    container.register<GuideMaterialApiRepository>(GuideMaterialApiRepository, {
      useFactory: (d) => {
        return new GuideMaterialApiRepository(
          d.resolve(ApiService),
          d.resolve(GuideMaterialDataMapper)
        )
      },
    })
    container.register<GalleryImageApiRepository>(GalleryImageApiRepository, {
      useFactory: (d) => {
        return new GalleryImageApiRepository(
          d.resolve(ApiService),
          d.resolve(GalleryImageDataMapper)
        )
      },
    })
    container.register<OtherContentApiRepository>(OtherContentApiRepository, {
      useFactory: (d) => {
        return new OtherContentApiRepository(
          d.resolve(ApiService),
          d.resolve(OtherContentDataMapper)
        )
      },
    })
    container.register<PositionApiRepository>(PositionApiRepository, {
      useFactory: (d) => {
        return new PositionApiRepository(
          d.resolve(ApiService),
          d.resolve(PositionDataMapper)
        )
      },
    })
    container.register<MasterCarApiRepository>(MasterCarApiRepository, {
      useFactory: (d) => {
        return new MasterCarApiRepository(
          d.resolve(ApiService),
          d.resolve(MasterCarDataMapper)
        )
      },
    })
    container.register<MasterApiRepository>(MasterApiRepository, {
      useFactory: (d) => {
        return new MasterApiRepository(
          d.resolve(ApiService),
          d.resolve(MasterDataMapper)
        )
      },
    })
    container.register<UserReportApiRepository>(UserReportApiRepository, {
      useFactory: (d) => {
        return new UserReportApiRepository(
          d.resolve(ApiService),
          d.resolve(UserReportDataMapper)
        )
      },
    })
    container.register<AdminCMSApiRepository>(AdminCMSApiRepository, {
      useFactory: (d) => {
        return new AdminCMSApiRepository(
          d.resolve(ApiService),
          d.resolve(AdminCMSMapper)
        )
      },
    })
    container.register<AdminCMSRoleApiRepository>(AdminCMSRoleApiRepository, {
      useFactory: (d) => {
        return new AdminCMSRoleApiRepository(
          d.resolve(ApiService),
          d.resolve(AdminCMSRoleDataMapper)
        )
      },
    })
    container.register<BulletinReportApiRepository>(
      BulletinReportApiRepository,
      {
        useFactory: (d) => {
          return new BulletinReportApiRepository(
            d.resolve(ApiService),
            d.resolve(BulletinReportDataMapper)
          )
        },
      }
    )
    container.register<AdditionalInfoReportApiRepository>(
      AdditionalInfoReportApiRepository,
      {
        useFactory: (d) => {
          return new AdditionalInfoReportApiRepository(
            d.resolve(ApiService),
            d.resolve(AdditionalInfoReportDataMapper)
          )
        },
      }
    )
    container.register<NotificationReportApiRepository>(
      NotificationReportApiRepository,
      {
        useFactory: (d) => {
          return new NotificationReportApiRepository(
            d.resolve(ApiService),
            d.resolve(NotificationReportDataMapper)
          )
        },
      }
    )
    container.register<TrainingMaterialReportApiRepository>(
      TrainingMaterialReportApiRepository,
      {
        useFactory: (d) => {
          return new TrainingMaterialReportApiRepository(
            d.resolve(ApiService),
            d.resolve(TrainingMaterialReportDataMapper)
          )
        },
      }
    )
    container.register<QuickGuideReportApiRepository>(
      QuickGuideReportApiRepository,
      {
        useFactory: (d) => {
          return new QuickGuideReportApiRepository(
            d.resolve(ApiService),
            d.resolve(QuickGuideReportDataMapper)
          )
        },
      }
    )
  }
}
